const getConfigs = () => {
  const configs = localStorage.getItem('configs');

  if (!configs) {
    return {};
  }

  try {
    return JSON.parse(configs);
  } catch (e) {
    return {};
  }
};

export const setConfigs = (data) => {
  localStorage.setItem('configs', JSON.stringify(data));
};


export default getConfigs;
